import { render, staticRenderFns } from "./AhorroConsContaAtmosComponent.vue?vue&type=template&id=67a92a73&scoped=true&"
import script from "./AhorroConsContaAtmosComponent.vue?vue&type=script&lang=js&"
export * from "./AhorroConsContaAtmosComponent.vue?vue&type=script&lang=js&"
import style0 from "./AhorroConsContaAtmosComponent.vue?vue&type=style&index=0&id=67a92a73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a92a73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCol,VContainer,VDivider,VRow})
